// noinspection GraphQLUnresolvedReference

import axios from 'axios'
import { gql } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { ImagenCloudProps } from '../../../interfaces/imagen.ts'

export const gqlQuery = gql`
  mutation ARTICULO_IMPORTAR_IMAGEN(
    $cds: Int!
    $codigoArticulo: String!
    $codigoUnidadMedida: String!
    $file: Upload!
  ) {
    articuloImportarImagen(
      cds: $cds
      codigoArticulo: $codigoArticulo
      codigoUnidadMedida: $codigoUnidadMedida
      file: $file
    ) {
      filename
      id
      variants {
        medium
        public
        square
        thumbnail
      }
    }
  }
`

/**
 * @description Importación de imagen al articulo
 * @param codigoArticulo
 * @param codigoUnidadMedida
 * @param file
 */
export const apiArticuloImportarImagen = async (
  codigoArticulo: string,
  codigoUnidadMedida: string,
  file: File,
): Promise<ImagenCloudProps> => {
  // const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  const cds = 1
  // 1. Preparamos la operación GraphQL según el spec de Multipart Request
  const variables = {
    cds,
    codigoArticulo,
    codigoUnidadMedida,
    file: null,
  }

  const operations = JSON.stringify({
    query: gqlQuery,
    variables,
  })

  const mapQueryImagen = JSON.stringify({ '0': ['variables.file'] })
  const formData = new FormData()
  formData.append('operations', operations)
  formData.append('map', mapQueryImagen)
  formData.append('0', file)

  try {
    const { data } = await axios.post(import.meta.env.ISI_API_URL, formData, {
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    })

    // Manejo de errores específicos de GraphQL (ej. sintaxis, guards)
    if (data.errors) {
      if (Array.isArray(data.errors)) {
        throw Error(data.errors[0].message)
      }
      throw new Error(data.errors || data.errors.message)
    }

    return data.data.articuloImportarImagen
  } catch (error: any) {
    // Si axios falla o el backend devuelve errores de GQL
    throw new MyGraphQlError(error)
  }

  //   const formData = new FormData()
  //   const operations = JSON.stringify({ query: gqlQuery, variables })
  //   formData.append('operations', operations)
  //   const map = {
  //     '0': ['variables.file'],
  //   }
  //   formData.append('map', JSON.stringify(map))
  //   formData.append('0', file)
  //
  //   const resp = await axios({
  //     url: import.meta.env.ISI_API_URL,
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       'Content-Type': 'multipart/form-data',
  //     },
  //     method: 'post',
  //     data: formData,
  //   })
  //     .then((data) => data.data)
  //     .catch((e) => {
  //       throw new Error(e)
  //     })
  //   return resp.data.articuloImportarImagen
  // } catch (e: any) {
  //   throw new MyGraphQlError(e)
  // }
  //   }
}
